<template>
  <div
    v-if="store.state.initiateFlow"
    class="h-full bg-white z-50 overflow-y-auto overflow-x-hidden"
    :class="{ 'pt-16 sm:pt-0': isMatchingQuizFlow }"
  >
    <wizard-flow
      :flow-name="store.state.initiateFlow"
      :context="store.state.preconditions!"
      @flow-complete="handleFlowComplete"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import store from '@/modules/wizard/stores/wizard-flows.store'
import WizardFlow from '@/modules/wizard/components/wizard/WizardFlow.vue'

const isMatchingQuizFlow = computed(
  () => store.state.initiateFlow === 'MatchingQuizFlow',
)

provide('hasOverlayNavbar', isMatchingQuizFlow)

const handleFlowComplete = () => {
  store.clearInitiateFlow()
}
</script>
